// src/components/Blog/Blog.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Blog.css';
import { FiBookOpen, FiCalendar, FiArrowRight } from 'react-icons/fi';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Firestore'dan makaleleri anlık (real-time) olarak çekiyoruz kanka
  useEffect(() => {
    const q = query(collection(db, 'blogs'), orderBy('date', 'desc'));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const blogList = snapshot.docs.map(doc => ({
        firebaseId: doc.id, // Firestore'un orijinal doküman ID'si
        id: doc.id,         // Bağlantı için doc.id kullanıyoruz
        ...doc.data()
      }));
      setBlogs(blogList);
      setLoading(false);
    }, (error) => {
      console.error("Makaleler çekilirken hata oluştu:", error);
      setLoading(false);
    });

    // Temizleme fonksiyonu
    return () => unsubscribe();
  }, []);

  return (
    <div className="page-wrapper">
      <Navbar />

      {/* Üst Başlık (Hero) */}
      <div className="blog-header">
        <div className="blog-header-overlay"></div>
        <div className="container">
          <span className="blog-header-icon"><FiBookOpen /></span>
          <h1 className="page-title">Hukuki Makaleler & <span className="gold-text">Blog</span></h1>
          <p className="page-subtitle-text">Güncel yargı kararları, hukuki gelişmeler ve haklarınız hakkında bilgilendirici yazılar.</p>
          <p className="page-breadcrumb">Ana Sayfa / Blog</p>
        </div>
      </div>

      {/* Makaleler Listesi */}
      <section className="blog-list-section">
        <div className="container">
          {loading ? (
            <div className="no-blog-box">
              <p>Makaleler yükleniyor...</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="no-blog-box">
              <h3>Henüz Yayınlanmış Makale Bulunmuyor</h3>
              <p>Yönetim paneli üzerinden yeni hukuki makaleler eklendiğinde bu alanda otomatik olarak listelenecektir.</p>
            </div>
          ) : (
            <div className="blog-grid">
              {blogs.map((blog) => (
                <div key={blog.firebaseId} className="blog-card">
                  {/* Kapak Görseli Varsa Gösteriyoruz kanka */}
                  {blog.image && (
                    <div className="blog-card-img-wrapper">
                      <img src={blog.image} alt={blog.title} className="blog-card-img" />
                    </div>
                  )}

                  <div className="blog-card-content">
                    <div className="blog-card-header">
                      <span className="blog-category-tag">{blog.category}</span>
                      <span className="blog-date"><FiCalendar /> {blog.date}</span>
                    </div>
                    <h3 className="blog-card-title">{blog.title}</h3>
                    <p className="blog-card-summary">{blog.summary}</p>
                    <Link to={`/blog/${blog.firebaseId}`} className="read-more-btn" style={{ textDecoration: 'none' }}>
                      <span>Devamını Oku</span> <FiArrowRight />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Blog;